import MassActionsBar from '@components/v2/layout/MassActionsBar/MassActionsBar';
import Button from '@components/v2/ui/Button/Button';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import LangEnum from '../../../../../lang/LangEnum';
import { ProductDetailsTestIds } from '../../../../../utils/testIds/productDetails.testIds';
import { useTranslation } from '../../../../translation/TranslationContext';
import { useProductDetailsMassActionBarStyles } from './productDetailsMassActionBar.styles';

export interface ProductDetailsMassActionBarProps {
  totalItems: number;
  totalSelected: number;
  isAllItemsSelected: boolean;
  isPasteDisabled?: boolean;
  blockReasonMessage?: string;
  onClickPaste: () => void;
  toggleSelectAllItems: () => void;
  deselectAllItems: () => void;
}

const noop = () => undefined;

const ProductDetailsMassActionBar = ({
  totalItems,
  totalSelected,
  isAllItemsSelected,
  isPasteDisabled,
  blockReasonMessage,
  onClickPaste,
  toggleSelectAllItems,
  deselectAllItems,
}: ProductDetailsMassActionBarProps) => {
  const { translate } = useTranslation();
  const { classes } = useProductDetailsMassActionBarStyles();

  return (
    <div className={classes.root}>
      <MassActionsBar<string>
        actions={[]}
        totalSelected={totalSelected}
        isAllSelected={isAllItemsSelected}
        testId={ProductDetailsTestIds.MASS_ACTION_BAR}
        onClickAction={noop}
        toggleAllSelected={toggleSelectAllItems}
        deselectAll={deselectAllItems}
        massActionFilter={{
          enabled: true,
          value: isAllItemsSelected,
          totalResults: totalItems,
          onToggle: toggleSelectAllItems,
        }}
        slots={{
          trailing: (
            <Tooltip TooltipContent={blockReasonMessage}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                disabled={isPasteDisabled}
                className={classes.pasteToAllButton}
                testId={ProductDetailsTestIds.MASS_ACTION_PASTE_TO_ALL}
                onClick={onClickPaste}
              >
                {translate(LangEnum.ORDER_PRODUCTS_GRID_PASTE_TO_ALL_MASS_ACTION_LABEL)}
              </Button>
            </Tooltip>
          ),
        }}
      />
    </div>
  );
};

export default ProductDetailsMassActionBar;
